import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

import Preloader from "../helper/Preloader";
import BannerOne from "../components/BannerOne";
import FeaturedOne from "../components/FeaturedOne";
import Problems from "../components/Problems";
import ServiceOne from "../components/ServiceOne";
import Faq from "../components/Faq";
import Testimonial from "../components/Testimonial";
import BrandSectionOne from "../components/BrandSectionOne";
import BecomeSellerTwo from "../components/BecomeSellerTwo";
import { useTheme } from "../components/ThemeProvider";

const HomePage = ({ openModal }) => {
  const { t, i18n } = useTranslation();
  const { isDarkMode } = useTheme();

  const faqHy = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Ինչքա՞ն ժամանակ է պահանջվում համակարգի տեղադրումը",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Տեղադրումն իրականացվում է հաշված օրերի ընթացքում՝ կախված տարածքի չափից և տեխնիկական պահանջներից։",
        },
      },
      {
        "@type": "Question",
        name: "Կարո՞ղ ենք արդյոք ինտեգրել համակարգը մեր արդեն իսկ գոյություն ունեցող սարքավորումներին",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Այո, Ari Ari-ն նախագծված է լինում ըստ տարածքի առանձնահատկությունների և կարող է ինտեգրվել առկա տեսախցիկների, ուղեփակոցների և վճարային տերմինալների հետ։",
        },
      },
      {
        "@type": "Question",
        name: "Արդյո՞ք կարող ենք հանգիստ լինել մեր կայանման տարածքի անվտանգության առումով։",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Տեսախցիկները մշտապես վերահսկում են տարածքը և պահպանում տվյալներ ամեն մուտքի, վճարման ու դեպքի վերաբերյալ։",
        },
      },
      {
        "@type": "Question",
        name: "Համակարգը համապատասխանու՞մ է արդյոք անվտանգության և տվյալների պահպանման ստանդարտներին:",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Համակարգը լիովին համապատասխանում է ISO 27001 և GDPR պահանջներին։",
        },
      },
      {
        "@type": "Question",
        name: "Ի՞նչ արժե համակարգը:",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Գինը հաշվարկվում է ըստ տարածքի չափի և պահանջվող ֆունկցիոնալության։ Կապվե՛ք մեզ հետ՝ անհատական առաջարկ ստանալու համար։",
        },
      },
      {
        "@type": "Question",
        name: "Կարո՞ղ են օգտատերերը վճարել առանց ֆիզիկական տերմինալի մոտենալու",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Այո, շուտով Ari Ari-ի հավելվածով հնարավոր կլինի ստանալ ծանուցում, տեսնել կայանման պատմությունը և վճարել՝ հեռավար կերպով։",
        },
      },
    ],
  };

  const faqEn = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How long does it take to install the system?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Installation is completed within a few days, depending on the size of the parking area and technical requirements.",
        },
      },
      {
        "@type": "Question",
        name: "Can we integrate the system with our existing equipment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Ari Ari is designed based on the specifics of your location and can integrate with existing cameras, barriers, and payment terminals.",
        },
      },
      {
        "@type": "Question",
        name: "Is the parking area secure with Ari Ari?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Cameras constantly monitor the area and store data for every entry, payment, and incident.",
        },
      },
      {
        "@type": "Question",
        name: "Is the system compliant with data protection and security standards?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The system is fully compliant with ISO 27001 and GDPR standards.",
        },
      },
      {
        "@type": "Question",
        name: "How much does the system cost?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The cost is calculated based on the size of the parking area and required functionality. Contact us for a personalized quote.",
        },
      },
      {
        "@type": "Question",
        name: "Can users pay without approaching a physical terminal?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, with the upcoming Ari Ari app, users will be able to receive notifications, view their parking history, and make remote payments.",
        },
      },
    ],
  };
  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(i18n.language === "hy" ? faqHy : faqEn)}
        </script>
      </Helmet>
      <section className="change-gradient">
        {/* Preloader */}
        <Preloader />

        {/* BannerOne */}
        <BannerOne
          setOpenGetDemoModal={() => openModal("getDemo")}
          setOpenCalendlyModal={() => openModal("calendly")}
        />

        {/* BrandSectionOne */}
        <BrandSectionOne />

        {/* FeaturedOne */}
        <div id="about">
          <FeaturedOne
            title={t("aboutSection.title")}
            descriptionLine1={t("aboutSection.desc")}
            direction={"text-left"}
            img={`/assets/images/thumbs/aboutUs_img-terminal_${isDarkMode ? "light" : "dark"}.webp`}
            withoutPadding={true}
            isGradient={true}
          />
        </div>

        {/* FeaturedOne */}
        {/* <div>
        <FeaturedOne
          title={t("aboutApp.title")}
          descriptionLine1={t("aboutApp.desc1")}
          descriptionLine2={t("aboutApp.desc2")}
          direction={"text-right"}
          showBtn={true}
          btn1Text={t("aboutApp.buttons.ios")}
          btn2Text={t("aboutApp.buttons.android")}
          img={`/assets/images/thumbs/ari-ari-order-mobile-app.png`}
          isContainer={true}
          withoutPadding={false}
        />
      </div> */}

        {/* Problems */}
        <Problems direction={"text-right"} />

        {/* Solutions */}
        <ServiceOne />

        {/* Testimonial */}
        <Testimonial />

        {/* BecomeSellerTwo */}
        <BecomeSellerTwo setOpenEbookModal={() => openModal("ebook")} />

        {/* Faq */}
        <Faq />
      </section>
    </>
  );
};

export default HomePage;
